import {defineStore} from "pinia";
const useSettingStore = defineStore({
    id:"setting",
    state:()=>{
        return {
            lock:false,
            mode:1,
            volume:5,
            color:'rgba(255, 69, 0, 0.68)',
        }
    },
    actions:{
        changeMode(){
            this.mode++;
            if (this.mode>4) {
                this.mode = 1
            }
        },
    },
    persist: {
        enabled: true,
        strategies: [
            { storage: localStorage, paths: ['lock','mode','volume','color'] },
        ],
    },
})

export default useSettingStore;
